import { Container, Box, Typography, Button, Card } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useNavigate } from 'react-router-dom';

interface PermissionDeniedProps {
    requiredPermission?: string;
    message?: string;
}

export default function PermissionDenied(props: PermissionDeniedProps) {
    const { requiredPermission, message } = props;
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/events');
    };

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100vh',
                    py: 4,
                }}
            >
                <Card
                    sx={{
                        p: 4,
                        textAlign: 'center',
                        width: '100%',
                    }}
                >
                    <Box sx={{ mb: 3 }}>
                        <LockIcon
                            sx={{
                                fontSize: '3rem',
                                color: 'warning.main',
                            }}
                        />
                    </Box>

                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                        Access Denied
                    </Typography>

                    <Typography variant="body1" color="textSecondary" sx={{ mb: 2 }}>
                        {message ||
                            `You don't have permission to access this ${requiredPermission ? `(${requiredPermission})` : 'content'}.`}
                    </Typography>

                    <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                        Please contact your administrator if you believe this is a mistake.
                    </Typography>

                    <Button variant="contained" color="primary" onClick={handleGoHome} fullWidth>
                        Go to Events
                    </Button>
                </Card>
            </Box>
        </Container>
    );
}
